import { CartService } from '@/services'
import { SALE_TYPE } from '@/constants'

export default {
  namespaced: true,
  state: () => ({
    carts: [],
    shippingFee: 0,
    freeAmount: 0,
    subscription: 1,
    deliveryId: null,
    normalCartsSummary: null,
    subscriptionCartsSummary: null,
    amountChangeFlag: false,
    isNotBundledRemoteIsland: false,
  }),
  getters: {
    normalCarts(state) {
      return state.carts.filter((cart) => !cart.subscription)
    },
    subscriptionCarts(state) {
      return state.carts.filter((cart) => cart.subscription)
    },
    normalCartsSummary(state) {
      return state.normalCartsSummary
    },
    subscriptionCartsSummary(state) {
      return state.subscriptionCartsSummary
    },
    totalItem(state) {
      return state.carts.length
    },
    shippingFee(state) {
      return state.shippingFee
    },
    freeAmount(state) {
      return state.freeAmount
    },
    subscription(state) {
      return state.subscription
    },
    deliveryId(state) {
      return state.deliveryId
    },
    amountChangeFlag(state) {
      return state.amountChangeFlag
    },
    isNotBundledRemoteIsland(state) {
      return state.isNotBundledRemoteIsland
    },
  },
  actions: {
    async ADD_CART({ commit, state, rootGetters }, { id, product_code, sale_type, quantity, subscription, ...args }) {
      const user = rootGetters['auth/user']

      const index = state.carts.findIndex((i) => i.id === id && Number(i.subscription) === Number(subscription))
      const syncCartItem =
        index > -1
          ? Object.assign({
              ...state.carts[index],
              quantity: state.carts[index].quantity + quantity,
              ...args,
            })
          : { id, product_code, sale_type, quantity, subscription, ...args }

      if (user) {
        if (index === -1) {
          const { data } = await CartService.addCartItem({
            product_sku_id: syncCartItem.id,
            quantity: syncCartItem.quantity,
            sale_type:
              syncCartItem.sale_type !== SALE_TYPE.BOTH
                ? syncCartItem.sale_type
                : syncCartItem.subscription
                ? SALE_TYPE.SUBSCRIPTION
                : SALE_TYPE.NORMAL,
          })
          syncCartItem.cart_item_id = data.cart_item_id
        } else {
          await CartService.updateCartItem(syncCartItem.cart_item_id, {
            product_sku_id: syncCartItem.id,
            quantity: syncCartItem.quantity,
          })
        }
      }

      commit('UPDATE_CART_ITEM', { index, syncCartItem })
    },
    async UPDATE_QUANTITY_ITEM({ commit, state, rootGetters }, { id, quantity, subscription }) {
      const user = rootGetters['auth/user']

      if (user) {
        const cart = state.carts.find((i) => i.id === id && Number(i.subscription) === Number(subscription))

        cart?.cart_item_id &&
          quantity > 0 &&
          (await CartService.updateCartItem(cart.cart_item_id, {
            product_sku_id: cart.id,
            quantity: quantity,
          }))
      }

      commit('UPDATE_QUANTITY_ITEM', { id, quantity, subscription })
    },
    async REMOVE_CART_ITEM({ commit, state, rootGetters }, { id, subscription }) {
      const user = rootGetters['auth/user']

      const index = state.carts.findIndex((i) => i.id === id && Number(i.subscription) === Number(subscription))

      if (index !== -1) {
        if (user) {
          const item = Object.assign({ ...state.carts[index] })

          if (item.cart_item_id) {
            await CartService.deleteCartItem(item.cart_item_id)
          }
        }
        commit('UPDATE_CART_ITEM', { index, syncCartItem: null })
      }
    },
  },
  mutations: {
    UPDATE_CART_ITEM(state, { index, syncCartItem }) {
      syncCartItem
        ? index === -1
          ? state.carts.push(syncCartItem)
          : state.carts.splice(index, 1, syncCartItem)
        : state.carts.splice(index, 1)
    },
    SET_SHIPPING_FEE(state, shippingFee) {
      state.shippingFee = shippingFee
    },
    SET_FREE_AMOUNT(state, freeAmount) {
      state.freeAmount = freeAmount
    },
    SET_CART(state, carts) {
      state.carts = carts
    },
    UPDATE_QUANTITY_ITEM(state, { id, quantity, subscription }) {
      const idx = state.carts.findIndex((i) => i.id === id && Number(i.subscription) === Number(subscription))

      idx > -1 && (state.carts[idx].quantity = quantity)
    },
    SET_SUBSCRIPTION(state, val) {
      state.subscription = val
    },
    EMPTY_CART(state, payload = undefined) {
      if (payload === undefined) {
        state.carts = []
      } else {
        state.carts = state.carts.filter((i) => Number(i.subscription) !== Number(payload))
      }
    },
    SET_DELIVERY_ID(state, val) {
      state.deliveryId = val
    },
    SET_NOMAL_CARTS_SUMMARY(state, val) {
      state.normalCartsSummary = val
    },
    SET_SUBSCRIPTION_CARTS_SUMMARY(state, val) {
      state.subscriptionCartsSummary = val
    },
    SET_AMOUNT_CHANGE_FLAG(state, val) {
      state.amountChangeFlag = val
    },
    SET_IS_NOT_BUNDLED_REMOTE_ISLAND(state, val) {
      state.isNotBundledRemoteIsland = val
    },
  },
}
